import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  PermissionEnum,
  Response,
  Account,
  apiAbortController,
  Currency,
} from '@ui/src';
import api from '../../api/api';
import { RateSource } from '../types';

export interface PermissionResponse {
  permissions: PermissionEnum[];
}

export const exchangeComponentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getExchangePermissions: build.query<{ data: PermissionResponse }, void>({
      query: () => ({ url: '/v1/employees/whoami' }),
    }),
    getExchangeDictionaries: build.query<any, void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const dictionaries = await Promise.all([
          fetchWithBQ('/v1/tariffs?all=true'),
          fetchWithBQ('/v1/risk-score-ranges?all=true'),
        ]);

        return dictionaries
          ? {
              data: {
                tariffs: dictionaries[0].data,
                riskScoreRanges: dictionaries[1].data,
              },
            }
          : { error: { status: 'FETCH_ERROR' } as FetchBaseQueryError };
      },
    }),
    getCurrenciesExchangeRateSources: build.query<Response<RateSource>, void>({
      query: () => ({
        url: '/v1/rates-sources?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getCurrenciesExchangeCurrencies: build.query<Response<Currency>, void>({
      query: () => ({
        url: '/v1/currencies?active=true&all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getExchangeAccounts: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getExchangeWhitelabel: build.query<
      { data: { data: { value: Record<string, string> } } },
      void
    >({ query: () => ({ url: '/v1/settings/whitelabel' }) }),
  }),
});

export const {
  useLazyGetExchangePermissionsQuery,
  useGetExchangeDictionariesQuery,
  useLazyGetExchangeDictionariesQuery,
  useLazyGetExchangeAccountsQuery,
  useLazyGetExchangeWhitelabelQuery,
  useLazyGetCurrenciesExchangeCurrenciesQuery,
  useLazyGetCurrenciesExchangeRateSourcesQuery,
} = exchangeComponentApi;

export const {
  endpoints: {
    getExchangePermissions,
    getExchangeDictionaries,
    getExchangeAccounts,
    getCurrenciesExchangeCurrencies,
    getCurrenciesExchangeRateSources,
  },
} = exchangeComponentApi;
